import SpecialityServiceCard from './SpecialityServiceCard'

export default SpecialityServiceCard
